import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IModalContext } from '../../../../models';
import { LogoOverlayGallery } from '../../../components-v2/UnifiedImageDialog/LogoOverlayGallery';
import { asModalComponent } from '../../Modal';
import { styleSheet } from './styles';

interface IProps extends IModalContext<Api.IFileAttachment> {
	images?: Api.IFileAttachment[];
	initialImageUrl?: string;
	showOverlayLogo?: boolean;
	logoUrl?: string;
	hideWhiteBackground: boolean;
	logoSize?: number;
	/** Omitted where the size cannot change, which hides the slider. */
	onLogoSizeChange?: (size: number) => void;
}

function _SocialMediaImagesPreviewModal({
	images,
	initialImageUrl,
	showOverlayLogo,
	logoUrl,
	hideWhiteBackground,
	logoSize = Api.DEFAULT_LOGO_SIZE,
	onLogoSizeChange,
}: IProps) {
	// Media already carrying a burned-in logo gets no second one, as in the image dialog's Logo Overlay tab.
	const showLogo = !!showOverlayLogo && !images?.some(image => image.hasLogoOverlay);

	return (
		<div className={css(styleSheet.body)}>
			<LogoOverlayGallery
				hideWhiteBackground={hideWhiteBackground}
				images={images ?? []}
				initialImageId={images?.find(image => image.url === initialImageUrl)?.id}
				logoUrl={logoUrl}
				onSizeChange={showLogo ? onLogoSizeChange : undefined}
				showLogo={showLogo}
				size={logoSize}
			/>
		</div>
	);
}

const SocialMediaImagesPreview = observer(_SocialMediaImagesPreviewModal);

export const SocialMediaImagesPreviewModal = asModalComponent(SocialMediaImagesPreview, {
	className: `social-media-images-preview-modal`,
	shouldCloseOnOverlayClick: true,
	useDefaultHeader: true,
});
